<template>
    <div>
404 NotFound!!!
        <div>
            <router-link to="/">返回首页</router-link>
        </div>
    </div>

</template>

<script>
    export default {
        name:'NotFound'
    }
</script>

<style lang="scss" scoped>
body{
    color: red;
}
</style>